import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { BodyText, ContentfulImage, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemAllergen = (props: Props) => {
  const { iconAlt, iconUrl, name } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        {iconUrl ? (
          <ContentfulImage
            baseUrl={iconUrl}
            options={IMAGE_OPTIONS}
            alt={iconAlt}
            style={styles.icon}
            contentFit="contain"
          />
        ) : null}
      </View>

      <BodyText sizeMatch={['18']}>{name}</BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ICON_SIZE = 24;

const IMAGE_OPTIONS: ContentfulImageOptions = { fm: 'webp', h: 48, w: 48 };

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
    borderRadius: theme.radius.large,
    paddingVertical: theme.spacing['3'],
    paddingHorizontal: theme.spacing['4'],
  },
  iconContainer: {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  iconAlt: string;
  iconUrl: string | undefined;
  name: string;
};

type ContentfulImageOptions = ComponentProps<typeof ContentfulImage>['options'];
